<template>
  <div class="address-panel">
    <!-- <div class="add-box send-box">
      <div class="icon-box" :class="{'box-line': tabActive === 'land'}">
        <img class="radius-icon" src="https://ump.ems.com.cn/newmail-resources/images/special/stepBar/icon-send@3x.png" alt="">
      </div>
      <div class="info-box">
        <div class="left-box" @click="handleOpenAddSheet('send')">
          <span class="label" v-if="!senderAdd">请选择内地地址</span>
          <div class="add-info" v-if="senderAdd">
            <p class="address-text">{{senderAdd}}</p>
            <p class="address-detail" v-if="sendAddressDetail">{{sendAddressDetail}}</p>
            <p class="address-detail" v-if="senderPostCode && senderPostCode !== '0'">邮编：{{senderPostCode}}</p>
          </div>
        </div>
        <div class="address-book-icon" @click="linkToAddBook('send')">
          <i class="iconfont icon-address-book" />
          <span>地址簿</span>
        </div>
      </div>
    </div>
    <div class="line">
      <div  class="exchange" @click="$event=>exchangeAddInfo()">
        <i v-if="tabActive === 'land'" class='iconfont icon-exchange icon-swap-vertical'></i>
        <span v-else class="icon-swap-point"></span>
      </div>
    </div>
    <div class="add-box receive-box">
      <div class="icon-box" :class="{'box-line': tabActive === 'land'}">
        <img class="radius-icon" src="https://ump.ems.com.cn/newmail-resources/images/special/stepBar/icon-receive@3x.png" alt="">
      </div>
      <div class="info-box">
        <div class="left-box" @click="handleOpenAddSheet('receive')">
          <span class="label" v-if="!receiveAdd">{{ titleObj[tabActive] }}</span>
          <div class="add-info" v-if="receiveAdd">
            <p class="address-text">{{receiveAdd}}</p>
            <p class="address-detail" v-if="intProCity">{{intProCity}}</p>
            <p class="address-detail" v-if="receAddressDetail">{{receAddressDetail}}</p>
            <p class="address-detail" v-if="receivePostCode && receivePostCode !== '0'">邮编：{{receivePostCode}}</p>
          </div>
        </div>
        <div class="address-book-icon" @click="linkToAddBook('receive')">
          <i class="iconfont icon-address-book" />
          <span>地址簿</span>
        </div>
      </div>
    </div> -->

    <post-address-panel
      @change="exchangeAddInfo"
      :show-ex-change="tabActive === 'land'"
      :key="pannelKey"
    >
      <post-address-panel-item
        :mode="senderMode"
        :placeholder="!senderAdd ? '请选择内地地址' : senderAdd"
        :address="senderAddDetail"
        :name="senderAdd"
        text="地址簿"
        :ellipsis="3"
        @click="handleOpenAddSheet('send')"
        @text-click="linkToAddBook('send')"
        activePlaceholder="内地"
      >
      </post-address-panel-item>
      <post-address-panel-item
        type="primary"
        :mode="receiveMode"
        :placeholder="!receiveAdd ? titleObj[tabActive] : receiveAdd"
        :address="receiveAddDetail"
        :name="receiveAdd"
        text="地址簿"
        :ellipsis="3"
        @click="handleOpenAddSheet('receive')"
        @text-click="linkToAddBook('receive')"
        :activePlaceholder="receiveAddObj[tabActive]"
      ></post-address-panel-item>
    </post-address-panel>
  </div>
</template>
<script>
import { AddressPanel, AddressPanelItem, Button } from '@postui/postui'
export default {
  name: 'addressPanel',
  components: {
    [Button.name]: Button,
    [AddressPanel.name]: AddressPanel,
    [AddressPanelItem.name]: AddressPanelItem
  },
  props: {
    frontVueChannel: {
      type: Number
    },
    isWx: {
      type: Boolean
    },
    senderAdd: {
      type: String
    },
    senderPostCode: {
      type: String
    },
    sendAddressDetail: {
      type: String
    },
    receiveAdd: {
      type: String
    },
    intProCity: {
      type: String
    },
    receAddressDetail: {
      type: String
    },
    receivePostCode: {
      type: String
    },
    tabActive: {
      // tab 类似
      type: String
    }
  },
  data: function () {
    return {
      titleObj: {
        land: '请选择内地地址',
        sar: '请选择中国港澳台地址',
        int: '请选择国际地址'
      },
      pannelKey: 0,
      receiveAddObj: {
        land: '内地',
        sar: '中国港澳台',
        int: '国际'
      }
    }
  },
  computed: {
    senderMode () {
      return this.senderAdd ? 'content' : 'placeholder'
    },
    receiveMode () {
      return this.receiveAdd ? 'content' : 'placeholder'
    },
    senderAddDetail () {
      const address = this.sendAddressDetail || ''
      const postcode =
        this.senderPostCode && this.senderPostCode !== '0'
          ? `邮编：${this.senderPostCode}`
          : ''
      return `${address}\n${postcode}` || null
    },
    receiveAddDetail () {
      const receiveAddress = this.intProCity + this.receAddressDetail || ''
      const postcode =
        this.receivePostCode && this.receivePostCode !== '0'
          ? `邮编：${this.receivePostCode}`
          : ''
      return `${receiveAddress}\n${postcode}` || null
    }
  },
  watch: {
    senderMode () {
      this.pannelKey += 1
    },
    receiveMode () {
      this.pannelKey += 1
    }
  },
  methods: {
    linkToAddBook (type) {
      this.$emit('linkToAddBook', type)
    },
    handleOpenAddSheet (type) {
      this.$emit('handleOpenAddressType', type)
    },
    exchangeAddInfo () {
      this.$emit('exchangeAddInfo')
    }
  }
}
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
